'use client';

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from 'react';
import { SCREENS, type TailwindBreakpoint } from '~/modules/tailwind/config';

/** `true` once the viewport is at or above the named Tailwind breakpoint —
 * the JS-side counterpart to a `lg:` / `md:` etc. modifier. Hydration-safe via
 * `useSyncExternalStore`: the server snapshot is always `false`, so any logic
 * guarded by this hook stays off until the client confirms the viewport. */
export function useIsTailwindBreakpoint(breakpoint) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== breakpoint) {
    t0 = onChange => {
      const mql = window.matchMedia(`(min-width: ${SCREENS[breakpoint]})`);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    };
    t1 = () => window.matchMedia(`(min-width: ${SCREENS[breakpoint]})`).matches;
    $[0] = breakpoint;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  return useSyncExternalStore(t0, t1, _temp);
}
function _temp() {
  return false;
}